import * as React from "react";
import { IconSetting, IconGraduationCap, IconPerson, IconCityLocation, IconHomeWork, IconFactCheck, IconHomeFilled } from "@/assets/icons";
import { AppRoutes, CompanyRoutes, ExamRoutes, LearnerRoutes, LearningRoutes, RsoRoutes, UserSettingRoutes } from "@/routes/config";
import { TUserType, USER_TYPE } from "@/types/enum";

export type TMenuItemChild = {
  text: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  path: string;
  relatedRoutes: string[];
};

export type TMenuSection = {
  text: string;
  children: TMenuItemChild[];
};

export type TMenuItem = TMenuItemChild | TMenuSection;

// Shared menu items used across multiple roles
const dashboardMenu: TMenuItemChild = {
  text: "ホーム",
  icon: IconHomeFilled,
  path: AppRoutes.home,
  relatedRoutes: [AppRoutes.home],
};

const mainMenuSection: TMenuSection = {
  text: "メインメニュー",
  children: [
    {
      text: "受験手続",
      icon: IconFactCheck,
      path: AppRoutes.examSteps,
      relatedRoutes: ExamRoutes,
    },
    {
      text: "学習進捗",
      icon: IconGraduationCap,
      path: "/learning-progress",
      relatedRoutes: LearningRoutes,
    },
    {
      text: "外国人管理",
      icon: IconPerson,
      path: AppRoutes.learnerList,
      relatedRoutes: LearnerRoutes,
    },
  ],
};

const settingsMenuSection: TMenuSection = {
  text: "設定メニュー",
  children: [
    {
      text: "ユーザー設定",
      icon: IconSetting,
      path: AppRoutes.userSettingDetail,
      relatedRoutes: UserSettingRoutes,
    },
  ],
};

const getCompanyDetailSection = (companyId?: number): TMenuSection => {
  const companyDetailPath = companyId ? `/company/${companyId}/detail` : AppRoutes.companyDetail;
  return {
    text: "所属機関メニュー",
    children: [
      {
        text: "所属機関情報",
        icon: IconCityLocation,
        path: companyDetailPath,
        relatedRoutes: [companyDetailPath, AppRoutes.companyEdit],
      },
    ],
  };
};

const rsoMenus: TMenuItem[] = [
  dashboardMenu,
  mainMenuSection,
  {
    text: "登録支援機関様メニュー",
    children: [
      {
        text: "所属機関管理",
        icon: IconCityLocation,
        path: AppRoutes.companyList,
        relatedRoutes: CompanyRoutes,
      },
      {
        text: "登録支援機関情報",
        icon: IconHomeWork,
        path: AppRoutes.rsoDetail,
        relatedRoutes: RsoRoutes,
      },
    ],
  },
  settingsMenuSection,
];

// company_user and support_user share the same menu structure
const getCompanyBasedMenus = (companyId?: number): TMenuItem[] => [
  dashboardMenu,
  mainMenuSection,
  getCompanyDetailSection(companyId),
  settingsMenuSection,
];

export const getMenus = (userType?: TUserType, companyId?: number): TMenuItem[] => {
  if (!userType) return [];
  if (userType === USER_TYPE.RSO_USER) return rsoMenus;
  if (userType === USER_TYPE.COMPANY_USER || userType === USER_TYPE.SUPPORT_USER) {
    return getCompanyBasedMenus(companyId);
  }
  return rsoMenus;
};
